import React from "react";
import Facebook from "../facebook.svg";
import Youtube from "../youtube.svg";
import TikTok from "../tiktok.svg";
import Instagram from "../instagram.svg";
import { FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
  const socialLinks = [
    {
      href: "https://www.instagram.com/milarte.mi/",
      src: Instagram,
      alt: "Instagram",
    },
    {
      href: "https://www.tiktok.com/@milarteit?_t=ZN-8shsnggNJah&_r=1",
      src: TikTok,
      alt: "TikTok",
    },
    {
      href: "https://www.facebook.com/profile.php?id=61553129543902",
      src: Facebook,
      alt: "Facebook",
    },

    {
      href: "https://www.youtube.com/@MilArteAssociazioneCulturale",
      src: Youtube,
      alt: "YouTube",
    },
  ];

  return (
    <footer className="bg-gradient-to-b from-red-900 to-red-950 text-white py-10 px-6 md:px-12">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 border-b border-white/20 pb-8">
        {/* SEZIONE 1 - Indirizzo */}
        <div className="text-center md:text-left space-y-3">
          <h3 className="text-xl font-bold uppercase tracking-wide">MilArte</h3>
          <div className="flex justify-center md:justify-start items-start space-x-2 text-sm">
            <FaMapMarkerAlt className="mt-1 flex-shrink-0" />
            <a
              href="https://www.google.com/maps?q=Via+Giovanni+Scheiwiller,+7,+20139+Milano"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-amber-300 transition"
            >
              Via Giovanni Scheiwiller, 7<br />
              20139 Milano
            </a>
          </div>
        </div>

        {/* SEZIONE 2 - Contatti */}
        <div className="text-center md:text-left space-y-3">
          <h3 className="text-xl font-bold uppercase tracking-wide">
            Contatti
          </h3>
          <a
            href="mailto:milarte.mi@gmail.com"
            className="flex justify-center md:justify-start items-center space-x-2 hover:text-amber-300 transition text-sm"
          >
            <FaEnvelope />
            <span>milarte.mi@gmail.com</span>
          </a>
          <a
            href="mailto:milarte.mi@pec.it"
            className="flex justify-center md:justify-start items-center space-x-2 hover:text-amber-300 transition text-sm"
          >
            <FaEnvelope />
            <span>milarte.mi@pec.it</span>
          </a>
        </div>

        {/* SEZIONE 3 - Info legali + Social */}
        <div className="text-center md:text-right space-y-3">
          <h3 className="text-xl font-bold uppercase tracking-wide">
            Informazioni legali
          </h3>
          <a
            href="#privacy"
            className="underline hover:text-amber-300 transition text-sm"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Privacy
          </a>
          <p className="text-sm opacity-90">2024 © MILARTE C.F.: 97952360150</p>

          {/* Social icons */}
          <div className="flex justify-center md:justify-end space-x-5 pt-3">
            {socialLinks.map(({ href, src, alt }, index) => (
              <a
                key={index}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={alt}
                className="hover:scale-110 transition-transform"
              >
                <img src={src} alt={alt} className="w-6 h-6" />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="text-center text-xs text-white/70 mt-6">
        Sito sviluppato con ❤️ da MilArte
      </div>
    </footer>
  );
};

export default Footer;
